import styled from 'styled-components';
import { media } from '../../../theme/media';
import { Link as LinkComponent } from '../../../components/link/link.component';


export const LogoImage = styled.img`
  max-width: 100%;
`;

export const Link = styled(LinkComponent)`
  position: absolute;
  z-index: 1;
  width: 105px;
  ${media.mobile`
    width: 125px;
  `}
  
  ${media.tablet`
    width: 279px;
  `};
`;
